import { Grid } from '@mui/material';

import { useDispatch } from 'react-redux';

import { TabPanel } from 'common/components/TabBar/TabBar';
import {
	StyledLinedTab,
	StyledLinedTabs,
} from 'common/components/TabBar/TabBarList';
import { setUploadParserSelectedTab } from 'common/store/reducer/commonReducer';

import SelectSection from '../SelectSection/SelectSection';

import DocumentInfo from './DocumentInfo';

import styles from './ParseRegulationTabInfo.module.scss';

interface IUploadParseTab {
	selectedTab: number;
	parserHighlights: any;
}

const ParseRegulationTabInfo = (tabInfo: IUploadParseTab) => {
	const { selectedTab, parserHighlights } = tabInfo;
	const dispatch = useDispatch();

	const tabs = [
		{
			id: 1,
			label: 'Document Info',
			name: 'Document Info',
			show: true,
			children: <DocumentInfo />,
		},
		{
			id: 2,
			label: 'Select Sections',
			name: 'Actions',
			show: true,
			children: <SelectSection textArray={parserHighlights} />,
		},
	];

	const onTabChange = (event: any, newValue: number) => {
		dispatch(setUploadParserSelectedTab(newValue));
	};

	return (
		<div className={styles['dashboard-toolbar-tabs']}>
			<div className={styles['dashboard-toolbar-tabs-block']}>
				<StyledLinedTabs
					data-testid="dashboard-toolbar-maintab"
					value={selectedTab}
					onChange={onTabChange}
					aria-label="scrollable prevent tabs example"
				>
					{tabs.map((ele: any) => (
						<StyledLinedTab
							key={ele?.id}
							data-testid="dashboard-toolbar-actions"
							label={ele?.label}
						/>
					))}
				</StyledLinedTabs>
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
					{tabs.map((res, i) => (
						<TabPanel
							value={selectedTab || 0}
							index={i}
							key={`${res.id}-tab-panel-${res.label}`}
						>
							{res.children}
						</TabPanel>
					))}
				</Grid>
			</div>
		</div>
	);
};

export default ParseRegulationTabInfo;
